export { FundsPage } from './funds_page';
